var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pageActive)?_c('article',{staticClass:"iv2-article"},[_c('LayoutTitle',{attrs:{"news":_vm.news}}),_c('LayoutList',{attrs:{"news":_vm.news}})],1):_vm._e(),(_vm.loading)?_c('div',[_c('BaseLoading')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }